import React, { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import styles from "./FaqPage.module.css";
import { faqSections } from "../contents/faqData";

function FaqPage() {
  const location = useLocation();
  const initialHash = location.hash.replace("#", "");
  const [openItem, setOpenItem] = useState(initialHash || "");

  const validIds = useMemo(
    () => new Set(faqSections.flatMap((section) => section.items.map((item) => item.id))),
    []
  );

  useEffect(() => {
    const hash = location.hash.replace("#", "");
    if (!hash || !validIds.has(hash)) {
      return;
    }

    setOpenItem(hash);
    const frameId = window.requestAnimationFrame(() => {
      const element = document.getElementById(hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    });

    return () => window.cancelAnimationFrame(frameId);
  }, [location.hash, validIds]);

  const toggleItem = (id) => {
    setOpenItem((current) => {
      const nextOpenItem = current === id ? "" : id;
      const nextHash = nextOpenItem ? `/faq#${nextOpenItem}` : "/faq";
      window.history.replaceState(null, "", nextHash);
      return nextOpenItem;
    });
  };

  return (
    <div className={styles.faqPage}>
      <header className={styles.header}>
        <p className={styles.eyebrow}>
          <span className="accent-underline">FAQ</span> & Antworten
        </p>
        <h1 className={styles.title}>Häufige Fragen</h1>
        <p className={styles.intro}>
          Antworten auf typische Fragen zu Zusammenarbeit, Umsetzung,
          Systemanbindungen, Betrieb und den Leistungen von datacook.
        </p>
      </header>

      <div className={styles.sections}>
        {faqSections.map((section) => (
          <section key={section.title} className={styles.section}>
            <h2 className={styles.sectionTitle}>{section.title}</h2>
            <div className={styles.accordionList}>
              {section.items.map((item) => {
                const isOpen = openItem === item.id;

                return (
                  <article
                    key={item.id}
                    id={item.id}
                    className={`${styles.accordionItem} ${
                      isOpen ? styles.open : ""
                    }`}
                  >
                    <button
                      type="button"
                      className={styles.question}
                      onClick={() => toggleItem(item.id)}
                      aria-expanded={isOpen}
                      aria-controls={`${item.id}-answer`}
                    >
                      <span>{item.question}</span>
                      <span className={styles.symbol}>{isOpen ? "−" : "+"}</span>
                    </button>
                    <div
                      id={`${item.id}-answer`}
                      className={styles.answerWrap}
                    >
                      <div className={styles.answer}>
                        <p>{item.answer}</p>
                      </div>
                    </div>
                  </article>
                );
              })}
            </div>
          </section>
        ))}
      </div>
    </div>
  );
}

export default FaqPage;
